import {connect} from "react-redux";
import UserRatingList from "./UserRatingList";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../service/Lead/action";
import { getjuniorListingForHod, saveRatingForHod, checkStarForRating } from "../../../../service/Dealer/action";
import {emailDropdownData} from "../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
    juniorListHod:state.Dealer.juniorListHod,
    ratingByHod: state.Dealer.ratingByHod,
    getStarCheck: state.Dealer.getStarCheck,
    email: state.Dealer.getEmailDropdown,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter,
            getjuniorListingForHod,
            saveRatingForHod,
            checkStarForRating,
            emailDropdownData
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UserRatingList);
